import { createContext, useContext } from 'react';

export const UserLinkingStateContext = createContext<{ token?: string } | undefined>(undefined);

export const useUserLinkingState = () => {
  const context = useContext(UserLinkingStateContext);
  if (!context) {
    throw new Error('useUserLinkingState must be used within an UserLinkingStateContext.Provider');
  }
  return context;
};
